import { cn } from '@aitoken/ui/lib/utils';

/*
 * aitoken.tools 标志
 * 一个几何小写 “a”：圆是 token（一枚筹码），竖笔是工具的柄，圆里挖出播放三角——视频。
 * 32×32 网格；墨色底块 + 香槟金字形。深色底上底块与背景融为一体，只剩金色字形。
 */

export const LOGO_INK = '#14120f';
export const LOGO_GOLD = '#d2b886';

/** 纯字形（不含底块），供 favicon / OG 图复用。 */
export function LogoGlyph({ gold = LOGO_GOLD, ink = LOGO_INK }: { gold?: string; ink?: string }) {
  return (
    <>
      <circle cx="13.25" cy="17.25" r="8.25" fill={gold} />
      <rect x="20.5" y="7.5" width="4.5" height="18" rx="2.25" fill={gold} />
      <path d="M10.6 13.2v8.1l6.6-4.05z" fill={ink} />
    </>
  );
}

export function LogoMark({ className, tile = true }: { className?: string; tile?: boolean }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-7 shrink-0', className)} aria-hidden focusable="false">
      {tile ? <rect width="32" height="32" rx="8" fill={LOGO_INK} /> : null}
      <LogoGlyph />
    </svg>
  );
}

/**
 * 字标：aitoken 用 League Spartan 粗体，.tools 降一级灰度，域名即品牌名。
 * tone：深色底用 light（字为纸白），浅色底用 dark（字为墨色）。
 */
export function Wordmark({
  className,
  tone = 'light',
  tld = true,
  markClassName,
}: {
  className?: string;
  tone?: 'light' | 'dark';
  tld?: boolean;
  markClassName?: string;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark className={markClassName} />
      <span className="display text-[22px] leading-none tracking-[-0.03em]">
        <span className={tone === 'light' ? 'text-[#f0efed]' : 'text-ink'}>aitoken</span>
        {tld ? <span className={tone === 'light' ? 'text-[#a39c90]' : 'text-[#6b645a]'}>.tools</span> : null}
      </span>
    </span>
  );
}
